import { render, staticRenderFns } from "./FormManageView.vue?vue&type=template&id=bb83370c"
import script from "./FormManageView.vue?vue&type=script&lang=js"
export * from "./FormManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports